/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AlertNote/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AlertNote({
  children,
  viewPath = "/DesignSystem/CheckIn/Confirmation/Content/AlertNotes/Content/AlertNote"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let alertNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'alert_note',
path: 'note',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let alertNoteCreatedByPersonValueData = fromData.useDataValue({ viewPath,
context: 'alert_note',
path: 'createdByPerson',
})
let constantData = 'N/A'
let aggregateData = fromAggregate.any(alertNoteCreatedByPersonValueData, constantData)
let alertNoteLastModifiedValueData = fromData.useDataValue({ viewPath,
context: 'alert_note',
path: 'lastModified',
})
  return (<React.Fragment
>
<div
  data-testid="AlertNote.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-D679R': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="justify"
 textOverflow="wrap"
 data="alert_note.note"
 text={alertNoteNoteValueData}
/>
<div
  data-testid="AlertNote.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral600}
 text="By"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="alert_note.createdByPerson"
 data="'N/A'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 marginRight={dtSpaceXxs}
 text=","
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="alert_note.lastModified"
 text={alertNoteLastModifiedValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}